import { useContext, useEffect } from 'react';
import { GridSortContext } from '../context/Grid.sort.context';

export const useSetCurrentWorkspace = () => {
  const {
    setCurrentWorkspaceUuid,
    workspaces
  } = useContext(GridSortContext);

  useEffect(() => {
    const currentWorkspace = workspaces?.find((w) => w.isActive);
    if (currentWorkspace) {
      setCurrentWorkspaceUuid(currentWorkspace.uuid);
    }
  }, []);
};
